module.exports = __webpack_public_path__ + "img/canvaBorderRight.ad0731c5.svg";